import firebase from '../firebase'
import axios from 'axios'

class CurrencyService {

  constructor () {
    let date = new Date()
    let day = `${(date.getUTCDate() < 10 ? 0 : '')}${date.getUTCDate()}`
    let month = `${(date.getUTCMonth() + 1 < 10 ? 0 : '')}${date.getUTCMonth() + 1}`
    this.date = `${month}-${day}-${date.getUTCFullYear()}`
  }

  async fetch () {
    let result = await firebase.db.child('currencies').child(this.date).once('value', snap => {
      return snap.val()
    })
    if (result.val()) {
      return {
        fire: true,
        result: result.val()
      }
    } else {
      let data = await this.getCurrenciesFromApi()
      return {
        fire: false,
        result: data
      }
    }
  }

  async getCurrenciesFromApi () {
    let data = await axios.get('http://apilayer.net/api/live?access_key=04c50dc47a09bd931efceda81e7f00e8')
    data = data.data.quotes
    await firebase.db.child('currencies').child(this.date).set(data)
    return data
  }

  async getCurrency (currency) {
    let result = await firebase.db.child('currencies').once('value', snap => {
      return snap.val()
    })
    return Object.keys(result.val()).map((date) => {
      let currencies = result.val()[date]
      let data
      for (let crc in currencies) {
        if (crc.substr(3, crc.length) == currency) {
          data = currencies[crc]
        }
      }
      return {
        date,
        data,
        currencies
      }
    })
  }

}

export default new CurrencyService()


// WEBPACK FOOTER //
// ./src/service/currency.js